import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable()
export class FileUploadService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'transaction/upload';

  constructor(private http: HttpClient) {
  }

  upload(formData: FormData, clientId) {
    return this.http.post(`${this.path}/${clientId}`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }
}
